// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"27edd2ba","138":"303ccc19","453":"e52d057f","493":"4746b6c8","621":"e7e08e66"}[chunkId] + ".chunk.js";
};